/**
 * 故障汇报资料管理
 * POST /api/produce/fault-report-material/query
 * POST /api/produce/fault-report-material/update
 */
import request from '@/router/axios'

const BASE = '/api/produce/fault-report-material'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

export function fetchFaultReportMaterialQuery(data) {
  return request({
    url: `${BASE}/query`,
    method: 'post',
    data: data || {},
    headers: { 'Content-Type': 'application/json' }
  }).then(unwrap)
}

export function updateFaultReportMaterial(data) {
  return request({
    url: `${BASE}/update`,
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/json' }
  }).then(unwrap)
}
